import { render, staticRenderFns } from "./CatalogCardListSkeleton.vue?vue&type=template&id=78ea6262&scoped=true"
import script from "./CatalogCardListSkeleton.vue?vue&type=script&lang=js"
export * from "./CatalogCardListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CatalogCardListSkeleton.vue?vue&type=style&index=0&id=78ea6262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea6262",
  null
  
)

export default component.exports